import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, idx) => ({
    '@type': 'ListItem' as const,
    position: idx + 1,
    item: item.href
      ? { '@id': `https://www.oumeizone.com${item.href}`, name: item.label }
      : { '@id': 'https://www.oumeizone.com', name: item.label },
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav aria-label="Breadcrumb" className="py-3">
        <ol className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1.5">
              {idx > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              )}
              {idx === items.length - 1 ? (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              ) : item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-600 transition-colors duration-200"
                >
                  {item.label}
                </Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}